import React, { createRef } from 'react';
import { AbortableCloseEvent, CloseEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isFunction, isMobileResolution, noop } from '@philips-internal/oswald-ui-utils';
import { FileUploaderContentMode } from '../components/file-uploader-content/file-uploader-content-types.js';
import { FileUploaderContent } from '../components/file-uploader-content/file-uploader-content.js';
import { FileService } from './file-service/file-service.js';
import { ModalService } from './modal-service/modal-service.js';
function createFileUploaderService() {
    const close = (id, onBeforeClose) => {
        if (isFunction(onBeforeClose)) {
            onBeforeClose(new AbortableCloseEvent({ abort: noop }));
        }
        ModalService.close(id);
    };
    const open = (props) => {
        const fileUploaderServiceRef = createRef();
        const { id, 
        // Adding a default here, in addition to the one already present in FileUploaderContent beacuse depending
        // on the execution order, when the `FileUploaderContent.defaultProps` gets interpretated, the value from `FileService.getFileHandler()`
        // may not be the intended from the application bootstrap, but the default from the constructor.
        fileHandlerInstance = FileService.getFileHandler(), onBeforeClose, modalProps, onClose, ...otherProps } = props;
        const onConfirmButtonClick = (hasMissingFiles) => {
            if (hasMissingFiles) {
                return;
            }
            close(id, onBeforeClose);
        };
        const onModalClose = () => {
            if (isFunction(props.onRequiredFileError)) {
                props.onRequiredFileError(Boolean(fileUploaderServiceRef.current?.hasMissingFiles()));
            }
            if (isFunction(onClose)) {
                onClose(new CloseEvent());
            }
        };
        const configuration = {
            ...modalProps,
            children: (React.createElement(FileUploaderContent, { ...otherProps, fileHandlerInstance: fileHandlerInstance, mode: FileUploaderContentMode.CONTEXTUAL_BAR_WRAPPER, onConfirmButtonClick: onConfirmButtonClick, ref: fileUploaderServiceRef })),
            className: 'c-file-uploader-service-modal',
            id,
            noPadding: isMobileResolution(),
            onBeforeClose,
            onClose: onModalClose,
        };
        ModalService.openDefault(configuration);
    };
    return {
        close,
        open,
    };
}
const FileUploaderService = createFileUploaderService();
export { FileUploaderService, };
//# sourceMappingURL=file-uploader-service.js.map